// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".reactivate-button{\n  font-weight:700;\n  font-size:14px;\n  line-height:19px;\n  padding:0 22px;\n  border-radius:6px;\n  transition:all .2s;\n  height:37px\n}\n.reactivate-button_s{\n  height:38px\n}\n.reactivate-button_m{\n  height:48px;\n  border-radius:9999px;\n  padding-left:25px;\n  padding-right:25px\n}\n.reactivate-button_l{\n  height:60px;\n  border-radius:12px;\n  font-size:18px\n}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
